import { Link, useParams } from "react-router-dom";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import { images } from "@/data/images";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import { Header } from "@/layout";
import { Backdrop, Box, Button, Fade, Modal, Typography } from "@mui/material";
import List from "@mui/icons-material/List";
import Info from "@mui/icons-material/Info";
import { useState } from "react";

const Description = (props: { text: string }) => (
  <div className="image-gallery-mobile-description">{props.text}</div>
);

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  width: isBrowser ? "auto" : "70%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
  color: "white",
  backgroundImage: "linear-gradient(to right, #434343 0%, black 100%)",
};

const Desc = (props: { id: string }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Button
        color="info"
        variant="contained"
        size="large"
        className={isBrowser ? "info-button-browser" : "info-button-mobile"}
        startIcon={<Info />}
        onClick={handleOpen}
      >
        Détails
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              {images[parseInt(props.id)].title}
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              {images[parseInt(props.id)].desc}
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

const CtrlButtons = (props: { id: string }) => (
  <div className="control-buttons">
    <div style={{ width: "100%" }}>
      <Link to={`/products/${props.id}`}>
        <Button
          color="secondary"
          variant="contained"
          size="large"
          className={isBrowser ? "back-button-browser" : "back-button-mobile"}
          startIcon={<List />}
        >
          Retour à la ligne décorative
        </Button>
      </Link>
    </div>
    <div>
      <Desc id={props.id} />
    </div>
  </div>
);

export const ProductPage = () => {
  const { id, start } = useParams<"id" | "start">();
  if (id === undefined) {
    return <div>Product does not exist</div>;
  } else {
    const productId = parseInt(id, 10);
    let startIndex = 0;
    if (start !== undefined) {
      startIndex = parseInt(start, 10);
    }
    const description = `${images[productId].name}: ${images[productId].title}`;
    const productImages: ReactImageGalleryItem[] = images[productId].images.map(
      (img) => ({
        original: img,
        thumbnail: img.replace(".jpg", "-thumb.jpg"),
        description: description,
      })
    );
    return (
      <div
        className={
          isBrowser ? "app-image-gallery-browser" : "app-image-gallery-mobile"
        }
      >
        <MobileView>
          <Header />
        </MobileView>
        <ImageGallery
          renderCustomControls={() => (
            <BrowserView>
              <CtrlButtons id={id} />
            </BrowserView>
          )}
          startIndex={startIndex}
          items={productImages}
          thumbnailPosition={isBrowser ? "left" : "bottom"}
        />
        <MobileView>
          <Description text={description} />
          <CtrlButtons id={id} />
        </MobileView>
      </div>
    );
  }
};
